import { useEffect } from 'react'
import { Button } from '@iveco-ti/iveco-ds'
import * as Sentry from '@sentry/react'
import Cookies from 'js-cookie'
import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import Lottie from 'react-lottie'
import { useNavigate, useRouteError } from 'react-router'

import oilEngine from '@/assets/animations/fuel.json'
import Img from '@/assets/images/danger.png'
import { ROUTES } from '@/common/constants/routes'
import { COOKIES_KEYS } from '../constants/cookiesKeys'

export function Error() {
  const { t } = useTranslation('common')
  const error = useRouteError() as Error
  const navigate = useNavigate()
  const TOKEN = Cookies.get(COOKIES_KEYS.token)

  const handleNavigate = () => {
    navigate(TOKEN ? ROUTES.PANEL.NEWS : ROUTES.LOGIN.SIGN_IN)
  }

  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <div className="h-full w-full flex justify-center items-center">
      <div className="flex flex-1 flex-col justify-center items-center gap-4 p-4 min-w-1/2">
        <div className="flex items-start gap-8">
          <Lottie
            options={{
              animationData: oilEngine,
              loop: false,
              autoplay: true,
            }}
            height={180}
            width={180}
          />

          <div className="flex flex-col gap-12">
            <div className="space-y-4">
              <h1 className="text-6xl font-bold text-base-9002 flex items-center gap-2">
                {t('components.error.title')}
              </h1>

              <h2 className="text-2xl text-base-700">
                {t('components.error.subtitle')}
              </h2>

              <span className="text-base-500">
                Ocorreu um erro na aplicação, vamos começar novamente.
              </span>
            </div>

            <div className="max-w-fit">
              <Button.Root onClick={handleNavigate} color="danger">
                <Button.Icon icon={ArrowLeft} />

                {t('components.error.button')}
              </Button.Root>
            </div>
          </div>
        </div>
      </div>

      <div className="hidden md:flex justify-end h-screen ">
        <img src={Img} alt={t('components.not_found.image')} />
      </div>
    </div>
  )
}
